import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-brown text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold mb-6" style={{fontFamily: "'Cormorant Garamond', Georgia, serif"}}>Mama-Mam's Kitchen</h3>
            <div className="w-12 h-1 bg-gold mb-4"></div>
            <p className="text-gray-300 leading-relaxed">
              Where Sundays Feel Like Home. Honouring the memory of Marjorie John (<strong>Mama-Mam</strong>) through love, family and togetherness.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6" style={{fontFamily: "'Cormorant Garamond', Georgia, serif"}}>Quick Links</h3>
            <div className="w-12 h-1 bg-gold mb-4"></div>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-gold transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-gold transition-colors">Our Story</Link></li>
              <li><Link to="/menu" className="text-gray-300 hover:text-gold transition-colors">Menu</Link></li>
              <li><Link to="/gallery" className="text-gray-300 hover:text-gold transition-colors">Gallery</Link></li>
              <li><Link to="/how-it-works" className="text-gray-300 hover:text-gold transition-colors">How It Works</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-gold transition-colors">Testimonials</Link></li>
              <li><Link to="/reviews" className="text-gray-300 hover:text-gold transition-colors">Reviews</Link></li>
              <li><Link to="/next-event" className="text-gray-300 hover:text-gold transition-colors">Next Event</Link></li>
              <li><Link to="/reserve" className="text-gray-300 hover:text-gold transition-colors">Reserve</Link></li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-xl font-bold mb-6" style={{fontFamily: "'Cormorant Garamond', Georgia, serif"}}>Opening Hours</h3>
            <div className="w-12 h-1 bg-gold mb-4"></div>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center">
                <div className="w-2 h-2 bg-gold rounded-full mr-3"></div>
                <span><strong className="text-white">Sunday:</strong> 3:00 PM - 8:00 PM</span>
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-gray-500 rounded-full mr-3"></div>
                <span>Monday - Saturday: Closed</span>
              </li>
              <li className="text-gold font-semibold mt-6">
                Sunday Buffet Special
              </li>
              <li className="text-sm text-gray-400 italic">
                With live music & entertainment
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-6" style={{fontFamily: "'Cormorant Garamond', Georgia, serif"}}>Contact Us</h3>
            <div className="w-12 h-1 bg-gold mb-4"></div>
            <ul className="space-y-4 text-gray-300">
              <li className="flex items-start">
                <Phone className="w-5 h-5 mr-3 mt-1 flex-shrink-0 text-gold" />
                <a href="tel:07427056361" className="hover:text-gold transition-colors">07427 056361</a>
              </li>
              <li className="flex items-start">
                <Mail className="w-5 h-5 mr-3 mt-1 flex-shrink-0 text-gold" />
                <a href="mailto:mamamamskitchen@gmail.com" className="hover:text-gold transition-colors">mamamamskitchen@gmail.com</a>
              </li>
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 mt-1 flex-shrink-0 text-gold" />
                <span>London, UK</span>
              </li>
            </ul>
            
            {/* Social Media */}
            <div className="flex space-x-4 mt-8">
              <a href="https://www.instagram.com/mamamamskitchen/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gold-light rounded-full flex items-center justify-center text-brown hover:bg-gold transition-all" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/people/Mama-Mams-Kitchen/61586859164247/?wtsid=rdr_0WXVoJ8glW6tCFSLO" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gold-light rounded-full flex items-center justify-center text-brown hover:bg-gold transition-all" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-brown-light mt-12 pt-8 text-center">
          <div className="w-24 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-gray-300 text-lg">
            &copy; {new Date().getFullYear()} Mama-Mam's Kitchen. All rights reserved.
          </p>
          <p className="text-gold italic mt-2">Made with ❤️, love and soul food.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
